<template>
  <div :class="$style.box">
    <div
      :class="$style.content"
      :style="{
        backgroundImage: isSwiper
          ? `url('${$cdnUrl}/seckill/dialog/popup/tankuang_youxilibaokuang.png')`
          : `url('${$cdnUrl}/seckill/dialog/popup/tankuang_tongyongkuang.png')`,
      }"
    >
      <header :class="$style.title">
        <slot name="title"></slot>
      </header>
      <div v-if="!isSwiper" :class="$style.main">
        <slot name="main"></slot>
      </div>
      <footer v-if="!isSwiper" :class="$style.btn">
        <slot name="btn"></slot>
      </footer>
      <div v-if="isSwiper" :class="$style.gift">
        <slot name="pickGift"></slot>
      </div>
      <button v-if="isShowCloseBtn" :class="$style['close-btn']" @click="closeDialog"></button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isSwiper: {
      type: Boolean,
      default: false
    },
    isShowCloseBtn: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    closeDialog() {
      this.$bus.$emit('closeSeckillDialog')
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/_variable';
@import '~@/styles/mixins.scss';
.box {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.7);
  .content {
    position: relative;
    width: 85%;
    height: auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .title {
      width: 317px;
      height: 39px;
    }
    .main {
      width: 100%;
      height: 235px;
      padding: 13px 35.5px 26.4px 35.5px;
      margin-bottom: 35px;
    }
    .btn {
      position: absolute;
      bottom: 7%;
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 35px;
      padding: 0 12px;
      > img {
        width: 130px;
        height: 35px;
      }
    }
    .gift {
      width: 100%;
      height: auto;
      padding: 8.5px;
    }
    .close-btn {
      @include clearBtnDefaultStyle;
      position: absolute;
      top: -13px;
      right: -13px;
      width: 25px;
      height: 25px;
      background-image: url('#{$cdn-url-hm}/seckill/dialog/popup/tankuang_guanbi.png');
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
  }
}
</style>
